/* ==========================================================================
   Class 5 Performance — quick-add.js
   Product-card quick-add for listing pages (PLP). Loaded only where cards
   render with quick-add enabled (e.g. sections/main-collection.liquid).

   What it does:
     - Multi-variant cards: the "Add to cart" button opens an in-card panel of
       option swatches (color/size). Selecting options resolves the matching
       variant, writes it to the hidden [name="id"] input, and enables/labels
       the panel's add button. Unavailable combinations are greyed out.
     - Single-variant cards: no panel — the button is a direct submit.

   The card's form carries class="pdp-form", so the AJAX add + cart-drawer open
   is handled by the shared interceptor in global.js. This file only handles
   variant selection and opening/closing the panel — it never touches the cart.

   Markup hooks (see snippets/product-card.liquid):
     [data-quickadd]           card quick-add wrapper (per card)
     [data-quickadd-open]       button that opens the panel (multi-variant)
     [data-quickadd-panel]      the option panel (starts [hidden])
     [data-quickadd-close]      closes the panel
     .card-quickadd__form       the product form (also .pdp-form)
     .qa-swatch input           option radios (data-option-position)
     [data-option-select]       hidden native select mirror (source for JS)
     [data-pdp-variants]        <script type=application/json> of variants
     [data-pdp-variant-id]      hidden [name="id"] input (authoritative)
     [data-pdp-add]/[data-pdp-add-text]  add button + its label
   ========================================================================== */
(function () {
  "use strict";

  /* ---- Per-card variant resolution ---- */
  function setupForm(form) {
    var dataEl = form.querySelector("[data-pdp-variants]");
    var idInput = form.querySelector("[data-pdp-variant-id]");
    if (!dataEl || !idInput) return; // single-variant card: nothing to resolve

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var addBtn = form.querySelector("[data-pdp-add]");
    var addText = form.querySelector("[data-pdp-add-text]");

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll("[data-option-select]").forEach(function (sel) {
        opts[parseInt(sel.getAttribute("data-option-select"), 10) - 1] = sel.value;
      });
      if (opts.length === 0 && variants[0]) return variants[0].options;
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    // Grey out option values with no available variant given the other picks.
    function updateAvailability(opts) {
      form.querySelectorAll(".qa-swatch input").forEach(function (input) {
        var pos = parseInt(input.getAttribute("data-option-position"), 10) - 1;
        var test = opts.slice();
        test[pos] = input.value;
        var hit = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === test[i]; });
        });
        var label = input.closest(".qa-swatch");
        if (label) label.setAttribute("data-unavailable", (hit && hit.available) ? "false" : "true");
      });
    }

    function onChange() {
      // Mirror checked radios into the hidden native selects (source of truth).
      form.querySelectorAll(".qa-swatch input:checked").forEach(function (input) {
        var pos = input.getAttribute("data-option-position");
        var sel = form.querySelector('[data-option-select="' + pos + '"]');
        if (sel) sel.value = input.value;
      });
      var opts = selectedOptions();
      var variant = matchVariant(opts);
      updateAvailability(opts);

      if (variant) {
        idInput.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? "Add to cart" : "Sold out";
      } else {
        idInput.value = "";
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = "Unavailable";
      }
    }

    form.querySelectorAll(".qa-swatch input").forEach(function (input) {
      input.addEventListener("change", onChange);
    });
    updateAvailability(selectedOptions());
  }

  document.querySelectorAll(".card-quickadd__form").forEach(setupForm);

  /* ---- Panel open / close ---- */
  function closeAll(except) {
    document.querySelectorAll("[data-quickadd-panel]").forEach(function (p) {
      if (p === except || p.hidden) return;
      p.hidden = true;
      var card = p.closest(".product-card");
      if (card) card.classList.remove("is-qa-open");
    });
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-quickadd-open]");
    if (openBtn) {
      e.preventDefault();
      var wrap = openBtn.closest("[data-quickadd]");
      var panel = wrap && wrap.querySelector("[data-quickadd-panel]");
      if (!panel) return;
      closeAll(panel);
      panel.hidden = false;
      var card = panel.closest(".product-card");
      if (card) card.classList.add("is-qa-open");
      var first = panel.querySelector(".qa-swatch input, button");
      if (first) first.focus();
      return;
    }

    var closeBtn = e.target.closest("[data-quickadd-close]");
    if (closeBtn) {
      e.preventDefault();
      var p = closeBtn.closest("[data-quickadd-panel]");
      if (p) {
        p.hidden = true;
        var c = p.closest(".product-card");
        if (c) c.classList.remove("is-qa-open");
      }
      return;
    }

    // Click outside any panel/opener closes open panels.
    if (!e.target.closest("[data-quickadd-panel]") && !e.target.closest("[data-quickadd-open]")) {
      closeAll(null);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll(null);
  });

  // On add (form submit), close the panel — global.js opens the cart drawer.
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".card-quickadd__form");
    if (!form) return;
    var panel = form.querySelector("[data-quickadd-panel]");
    if (panel) {
      panel.hidden = true;
      var card = form.closest(".product-card");
      if (card) card.classList.remove("is-qa-open");
    }
  });
})();
